<div class="container">
    <!-- ── PAGE HEADER ── -->
    <div class="page-header">
        <span class="page-header-icon" style="background: rgba(255,255,255,0.15); color: #fff;">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="8.5" cy="7" r="4"></circle>
              <line x1="20" y1="8" x2="20" y2="14"></line>
              <line x1="23" y1="11" x2="17" y2="11"></line>
            </svg>
        </span>

        <div style="flex: 1;">
            <h1>{{ docParceiroEdicao ? 'Edição de Parceiro' : 'Cadastro de Parceiro' }}</h1>
            <p>{{ docParceiroEdicao ? 'Código: ' + (codParcEdicao || '—') : 'Digite um CPF/CNPJ' }}</p>
        </div>

        <div style="display: flex; gap: 10px; align-items: center;">
            <button type="button" class="btn-salvar-header"
                    [disabled]="salvando()" (click)="onSalvarParceiroClick()">
                <svg *ngIf="!salvando()" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                    <polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
                </svg>
                <app-loading-indicator *ngIf="salvando()" size="inline"></app-loading-indicator>
                Salvar
            </button>

            <button type="button" *ngIf="!docParceiroEdicao"
                    style="background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);color:#fff;border-radius:8px;padding:8px 16px;cursor:pointer;display:flex;align-items:center;gap:6px;font-size:13px;font-weight: 500;"
                    (click)="onLimparFormularioClick()">
                Limpar
            </button>

            <button type="button"
                    style="background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);color:#fff;border-radius:8px;padding:8px 16px;cursor:pointer;display:flex;align-items:center;gap:6px;font-size:13px;font-weight: 500;"
                    (click)="voltar.emit()" title="Voltar para a Lista de Parceiros">
                Voltar
            </button>
        </div>
    </div>

    <form [formGroup]="parceiroForm" (ngSubmit)="onSalvarParceiroClick($event)">

        <!-- Consultar cadastro de parceiro: oculto por enquanto (trocar false por true para reexibir) -->
        <div class="card" style="margin-bottom: 16px;" *ngIf="false">
            <div class="card-title" style="cursor: pointer; justify-content: space-between; margin-bottom: 0;" (click)="buscaColapsada = !buscaColapsada">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <span style="font-size: 16px;">🔍</span>
                    <span style="color: var(--primary);">Consultar cadastro de parceiro</span>
                </div>
                <button type="button" style="background: none; border: none; color: var(--text-muted); cursor: pointer; display: flex; align-items: center;">
                    <svg *ngIf="buscaColapsada" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    <svg *ngIf="!buscaColapsada" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
                </button>
            </div>

            <div class="form-grid" *ngIf="!buscaColapsada" style="padding-top: 16px; border-top: 1px solid #e2e8f0; margin-top: 12px;">
                <div class="field col-12" style="position: relative; margin-bottom: 0;" (click)="$event.stopPropagation()">
                    <div class="busca-combo">
                        <input type="text" class="busca-combo-input" style="padding: 10px 14px; font-size: 14px; background-color: #f8fafc;"
                               [(ngModel)]="filtroBuscaModalParceiroGeral"
                               [ngModelOptions]="{standalone: true}"
                               (input)="agendarBuscaParceiroGeral()"
                               (focus)="filtroBuscaModalParceiroGeral.trim().length >= 2 && (dropdownBuscaParceiroGeralAberto = true)"
                               placeholder="Digite o nome, código ou documento e selecione na lista abaixo..." autofocus>
                    </div>

                    <!-- DROPDOWN -->
                    <div class="autocomplete-dropdown" *ngIf="dropdownBuscaParceiroGeralAberto" style="max-height: 350px; overflow-y: auto; box-shadow: 0 10px 25px rgba(0,0,0,0.15); border: 1px solid #cbd5e1; z-index: 1000;">
                        <div class="autocomplete-item" style="padding: 14px 16px; border-bottom: 1px solid #f1f5f9; cursor: pointer;"
                             *ngFor="let p of listaParceirosGeralSugeridos()"
                             (mousedown)="selecionarParceiroGeral(p)">
                            <div style="font-weight: 700; color: var(--text-main); margin-bottom: 4px; font-size: 14px;">{{ p.nomeparc }}</div>
                            <div style="font-size: 12px; color: var(--text-muted);">
                                Doc: {{ formatarCpfCnpjExibicao(p.docparc) }}
                            </div>
                        </div>
                        <div class="autocomplete-empty" *ngIf="!listaParceirosGeralSugeridos().length" style="padding: 16px; text-align: center; color: var(--text-muted); font-size: 13px;">
                            {{ statusBuscaParceiroGeral() }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CARD PRINCIPAL (Mistura base + PF/PJ + Ambos) -->
        <div class="sub-card">
            <div class="sub-card-header"><strong>Dados Principais</strong></div>
            <div class="sub-card-body form-grid">

                <div class="field field-wide" style="margin-bottom: 3px; padding-bottom: 10px; border-bottom: 1px dashed #e2e8f0;">
                    <div style="display: flex; gap: 12px; flex-wrap: wrap;">
                        <label class="switch"><input type="checkbox" formControlName="isCliente"><span class="slider"></span><span class="switch-text">Cliente</span></label>
                        <div style="width: 20px; height: 20px;"></div>
                        <label class="switch"><input type="checkbox" formControlName="isFornecedor"><span class="slider"></span><span class="switch-text">Fornecedor</span></label>
                        <div style="width: 20px; height: 20px;"></div>
                        <label class="switch"><input type="checkbox" formControlName="isVendedor"><span class="slider"></span><span class="switch-text">Funcionário</span></label>
                        <div style="width: 20px; height: 20px;"></div>
                        <label class="switch"><input type="checkbox" formControlName="isTransportadora"><span class="slider"></span><span class="switch-text">Transportadora</span></label>
                        <div style="width: 20px; height: 20px;"></div>
                        <label class="switch"><input type="checkbox" formControlName="isAgencia"><span class="slider"></span><span class="switch-text">Ag&ecirc;ncia</span></label>
                        <div style="width: 20px; height: 20px;"></div>
                        <label class="switch"><input type="checkbox" formControlName="isMotorista"><span class="slider"></span><span class="switch-text">Motorista</span></label>
                        <div style="width: 20px; height: 20px;"></div>
                        <label class="switch"><span class="switch-text">Tipo Cadastro: </span></label>
                        <select formControlName="tipoCadastro">
                            <option value="AVISTA">&Agrave; Vista</option>
                            <option value="APRAZO">&Agrave; Prazo</option>
                            <option value="ENTREGA">Entrega</option>
                            <option value="RAPIDO">Rapido</option>
                        </select>
                        <div style="width: 20px; height: 20px;"></div>
                        <label class="switch"><span class="switch-text">Etapa Cadastro: </span></label>
                        <select formControlName="etapaCadastro">
                            <option value="COMPLETO">Completo</option>
                            <option value="PARCIAL">Parcial</option>
                        </select>
                        <label class="switch" style="margin-left: auto;"><input type="checkbox" formControlName="ativo"><span class="slider"></span><span class="switch-text">{{ parceiroForm.get('ativo')?.value ? 'Ativo' : 'Inativo' }}</span></label>
                    </div>
                </div>

                <!-- Básico -->
                <div class="field col-2">
                    <label>Tipo <span class="campo-obrigatorio-asterisco">*</span></label>
                    <select formControlName="tipoPessoa">
                        <option value="F">Física</option>
                        <option value="J">Jurídica</option>
                        <option value="E">Estrangeiro</option>
                    </select>
                </div>
                <div class="field col-2">
                    <label>CPF / CNPJ <span class="campo-obrigatorio-asterisco">*</span></label>
                    <input type="text" formControlName="cpfCnpj" (input)="aplicarMascaraCpfCnpj($event)" maxlength="18" (blur)="onCpfCnpjBlur()"
                    [class.campo-invalido]="parceiroForm.get('cpfCnpj')?.touched && parceiroForm.get('cpfCnpj')?.invalid">
                    <!-- MENSAGEM DE ERRO (Só aparece se estiver inválido e tocado) -->
                    <div *ngIf="parceiroForm.get('cpfCnpj')?.touched && parceiroForm.get('cpfCnpj')?.hasError('invalidCpf')" style="color: var(--danger); font-size: 10px; font-weight: 600;">
                        CPF inválido
                    </div>
                    <div *ngIf="parceiroForm.get('cpfCnpj')?.touched && parceiroForm.get('cpfCnpj')?.hasError('invalidCnpj')" style="color: var(--danger); font-size: 10px; font-weight: 600;">
                        CNPJ inválido
                    </div>
                </div>
                <div class="field col-8">
                    <label>Nome / Nome Fantasia <span class="campo-obrigatorio-asterisco">*</span></label>
                    <input type="text" formControlName="nome" [class.campo-invalido]="parceiroForm.get('nome')?.touched && parceiroForm.get('nome')?.invalid">
                </div>

                <div class="field col-8" *ngIf="parceiroForm.get('tipoPessoa')?.value === 'J'">
                    <label>Raz&atilde;o Social <span class="campo-obrigatorio-asterisco">*</span></label>
                    <input type="text" formControlName="razaoSocial" [class.campo-invalido]="parceiroForm.get('razaoSocial')?.touched && parceiroForm.get('razaoSocial')?.invalid">
                </div>

                <!-- ================= ESPECÍFICO PF ================= -->
                <ng-container *ngIf="parceiroForm.get('tipoPessoa')?.value === 'F'">
                    <div class="field col-2"><label>RG</label><input type="text" formControlName="rg" maxlength="20"></div>
                    <div class="field col-2"><label>Órg. Expedidor</label><input type="text" formControlName="orgaoExpedidor" maxlength="20"></div>
                    <div class="field col-2"><label>Emiss&atilde;o RG</label><input type="date" formControlName="dataEmissaoRg"></div>
                    <div class="field col-2"><label>Data Nasc.</label><input type="date" formControlName="dataNascimento"></div>
                    <div class="field col-2"><label>Sexo</label>
                        <select formControlName="sexo">
                            <option value="M">Masculino</option>
                            <option value="F">Feminino</option>
                            <option value="O">Outro</option>
                        </select>
                    </div>
                    <div class="field col-2" style="position: relative;" [class.busca-autocomplete-aberta]="dropdownNaturalidadeAberto()">
                        <label>Naturalidade</label>
                        
                        <div class="busca-combo">
                            <input type="text" class="busca-combo-input"
                                [value]="valorExibidoNaturalidade(parceiroForm.get('naturalidade')?.value)"
                                (input)="onInputNaturalidade($event)"
                                (keydown)="onKeyDownNavegacao($event, 'NATURALIDADE')"
                                (blur)="fecharDropdownNaturalidade()"
                                placeholder="Digite a cidade...">
                                
                            <button type="button" class="busca-combo-clear" style="color: var(--danger)"
                                    *ngIf="parceiroForm.get('naturalidade')?.value"
                                    (click)="parceiroForm.get('naturalidade')?.setValue('')">✕
                            </button>
                        </div>
                            
                        <div class="autocomplete-dropdown" *ngIf="dropdownNaturalidadeAberto()">
                            <div class="autocomplete-item"
                                 *ngFor="let c of cidadesFiltradasNaturalidade(); let i = index"
                                 [class.autocomplete-item-ativo]="indiceFocoAtual() === i"
                                 (mousedown)="selecionarNaturalidade(c)">
                                {{c.CODCID}} - {{c.NOMECID}}
                            </div>
                            <div class="autocomplete-empty" *ngIf="cidadesFiltradasNaturalidade().length === 0">Nenhuma cidade encontrada.</div>
                        </div>
                    </div>

                    <div class="field col-2"><label>CNH</label><input type="text" formControlName="cnh" maxlength="15"></div>
                    <div class="field col-2"><label>Venc. CNH</label><input type="date" formControlName="dataVencimentoCnh"></div>

                    <div class="field col-4"><label>Nome da M&atilde;e</label><input type="text" formControlName="nomeMae"></div>
                    <div class="field col-4"><label>Nome do Pai</label><input type="text" formControlName="nomePai"></div>
                </ng-container>

                <!-- ================= ESPECÍFICO PJ ou Ex ================= -->
                <ng-container *ngIf="parceiroForm.get('tipoPessoa')?.value !== 'F'">
                    <div class="field col-2"><label>Data Abertura</label><input type="date" formControlName="dataAbertura"></div>
                    <div class="col-10" *ngIf="parceiroForm.get('tipoPessoa')?.value === 'E'"></div>
                </ng-container>
                <!-- ================= ESPECÍFICO PJ ================= -->
                <ng-container *ngIf="parceiroForm.get('tipoPessoa')?.value === 'J'">
                    <div class="field col-2"><label>COM</label><input type="text" formControlName="com"></div>
                </ng-container>

                <!-- ================= AMBOS ================= -->
                
                <div class="field col-4" style="position: relative;" [class.busca-autocomplete-aberta]="dropdownVendedorAberto()">
                    <label>Vendedor Responsável</label>
                    
                    <div class="busca-combo">
                        <input type="text" class="busca-combo-input"
                            [value]="inputVendedorDisplay() || valorExibidoVendedor(parceiroForm.get('vendedorResponsavel')?.value)"
                            (input)="onInputVendedor($event)"
                            (keydown)="onKeyDownNavegacao($event, 'VENDEDOR')"
                            (blur)="fecharDropdownVendedor()"
                            placeholder="Digite o código ou nome...">
                            
                        <button type="button" class="busca-combo-clear" style="color: var(--danger)" 
                                *ngIf="parceiroForm.get('vendedorResponsavel')?.value"
                                (click)="parceiroForm.get('vendedorResponsavel')?.setValue(''); inputVendedorDisplay.set('')">✕
                        </button>
                    </div>
                    
                    <div class="autocomplete-dropdown" *ngIf="dropdownVendedorAberto()">
                        <div class="autocomplete-item"
                             *ngFor="let v of vendedoresFiltrados(); let i = index"
                             [class.autocomplete-item-ativo]="indiceFocoAtual() === i"
                             (mousedown)="selecionarVendedor(v)">
                            {{v.codVend}} - {{v.apelido}}
                        </div>
                        <div class="autocomplete-empty" *ngIf="vendedoresFiltrados().length === 0">Nenhum vendedor encontrado.</div>
                    </div>
                </div>

                <div class="field col-2">
                    <label>Pendência</label>
                    <select formControlName="gplPendencia">
                        <option value="OK">OK</option>
                        <option value="SPC">SPC</option>
                        <option value="SERASA">SERASA</option>
                        <option value="SPC/SERASA">SPC/SERASA</option>
                        <option value="INTERNA">INTERNA</option>
                        <option value="SEM CONSULTA">SEM CONSULTA</option>
                    </select>
                </div>
                <div class="field col-2">
                    <label>Conceito</label>
                    <select formControlName="gplConceito">
                        <option value="">Selecione...</option>
                        <option value="1">Somente à Vista</option>
                        <option value="2">Pode Faturar Conf. Limite</option>
                        <option value="3">Não Pontual</option>
                        <option value="4">Inadimplente, procurar o financeiro</option>
                        <option value="5">Somente Dados</option>
                    </select>
                </div>
                <div class="field col-2">
                    <label>Bloq. Venda a Prazo</label>
                    <select formControlName="bloquearVendaPrazo">
                        <option value="N">N&atilde;o</option>
                        <option value="S">Sim</option>
                    </select>
                </div>

                <div class="field col-2">
                    <label>Lim. Crédito (R$)</label>
                    <input type="text" formControlName="limiteCredito" (input)="aplicarMascaraLimiteCredito($event)">
                </div>

                <div class="field col-12">
                    <label>Observa&ccedil;&atilde;o</label>
                    <textarea formControlName="observacao" rows="6"></textarea>
                </div>
            </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px;">
            <!-- CARD COMPRADORES (Lista) -->
            <div class="card" style="margin-bottom: 0;">
                <div class="card-title" style="justify-content: space-between;">
                    Compradores Autorizados
                    <button type="button" class="btn secondary btn-sm" (click)="adicionarComprador()">+ Add</button>
                </div>
                <div formArrayName="compradores">
                    <div *ngFor="let comp of compradoresFormArray.controls; let i = index" [formGroupName]="i" class="sub-card">
                        <div class="sub-card-header">
                            <strong>Comprador {{ i + 1 }}</strong>
                            <button type="button" class="busca-combo-clear" (click)="removerComprador(i)">✕</button>
                        </div>
                        <div class="sub-card-body form-grid">
                            <div class="field col-7"><label>Nome</label><input type="text" formControlName="nome"></div>
                            <div class="field col-5">
                                <label>CPF</label>
                                <input type="text" formControlName="cpf" maxlength="14" (input)="aplicarMascaraSimplesCpf($event, i)">
                                <div *ngIf="comp.get('cpf')?.touched && comp.get('cpf')?.hasError('invalidCpf')"
                                     style="color: var(--danger); font-size: 10px; font-weight: 600;">
                                    CPF inválido
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="compradoresFormArray.length === 0" style="font-size: 11px; color: var(--text-muted); padding-top: 8px;">Nenhum comprador.</div>
                </div>
            </div>

            <!-- CARD FIADORES -->
            <div class="card" style="margin-bottom: 0;">
                <div class="card-title" style="justify-content: space-between;">
                    Fiadores
                    <button type="button" class="btn secondary btn-sm" (click)="adicionarFiador()">+ Add</button>
                </div>
                <div formArrayName="fiadores">
                    <div *ngFor="let fiadorCtrl of fiadoresFormArray.controls; let i = index" [formGroupName]="i" class="sub-card">
                        <div class="sub-card-header">
                            <strong>Fiador {{ i + 1 }}</strong>
                            <button type="button" class="busca-combo-clear" (click)="removerFiador(i)">✕</button>
                        </div>
                        <div class="sub-card-body form-grid">

                            <!-- Parceiro (Fiador) com Autocomplete (Mesmo padrão da Aeronave) -->
                            <div class="field col-7">
                                <label>Parceiro (Fiador) <span class="campo-obrigatorio-asterisco">*</span></label>
                                <div class="busca-combo" [class.campo-invalido]="fiadorCtrl.get('codParcFiador')?.touched && fiadorCtrl.get('codParcFiador')?.invalid">
                                    <button type="button" class="btn-busca" (click)="abrirModalFiador(i)" title="Buscar Fiador">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <circle cx="11" cy="11" r="7"></circle>
                                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                        </svg>
                                    </button>
                                    <input type="text" class="busca-combo-input"
                                           [value]="valorExibidoFiador(fiadorCtrl.get('codParcFiador')?.value, i)"
                                           placeholder="Clique para abrir a consulta"
                                           readonly
                                           (click)="abrirModalFiador(i)">
                                </div>
                            </div>

                            <div class="field col-5">
                                <label>Função</label>
                                <select formControlName="funcao">
                                    <option value="">Selecione...</option>
                                    <option value="AVALISTA">Avalista</option>
                                    <option value="SOCIO">Sócio</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="fiadoresFormArray.length === 0" style="font-size: 11px; color: var(--text-muted); padding-top: 8px;">Nenhum fiador vinculado.</div>
                </div>
            </div>
        </div>

        <!-- CARD REFERÊNCIAS BANCÁRIAS -->
        <div class="card" style="margin-top: 12px;">
            <div class="card-title" style="justify-content: space-between;">
                Refer&ecirc;ncias Banc&aacute;rias
                <button type="button" class="btn secondary btn-sm" (click)="adicionarRefBancaria()">+ Adicionar</button>
            </div>
            <div formArrayName="refsBancarias">
                <div *ngFor="let refCtrl of refsBancariasFormArray.controls; let i = index" [formGroupName]="i" class="sub-card">
                    <div class="sub-card-header">
                        <strong>Refer&ecirc;ncia {{ i + 1 }}</strong>
                        <button type="button" class="busca-combo-clear" (click)="removerRefBancaria(i)">✕</button>
                    </div>
                    <div class="sub-card-body form-grid">
                        <div class="field col-4">
                            <label>Banco</label>
                            <select formControlName="codBanco" (change)="sincronizarTipoAgencia()">
                                <option value="">Selecione...</option>
                                <option *ngFor="let b of bancos()" [value]="b.codBanco">{{ ('000' + b.codBanco).slice(-3) }} - {{ b.nome }}</option>
                            </select>
                        </div>
                        <div class="field col-2">
                            <label>Tipo de Conta</label>
                            <select formControlName="tipoConta">
                                <option *ngFor="let t of tiposConta" [value]="t">{{ t }}</option>
                            </select>
                        </div>
                        <div class="field col-2">
                            <label>Ag&ecirc;ncia</label>
                            <input type="text" formControlName="agencia" maxlength="20" (input)="sincronizarTipoAgencia()">
                        </div>
                        <div class="field col-1">
                            <label>Dig. Ag.</label>
                            <input type="text" formControlName="digAgencia" maxlength="10">
                        </div>
                        <div class="field col-2">
                            <label>N&ordm; da Conta</label>
                            <input type="text" formControlName="conta" maxlength="20" (input)="sincronizarTipoAgencia()">
                        </div>
                        <div class="field col-1">
                            <label>Dig. Conta</label>
                            <input type="text" formControlName="digConta" maxlength="10">
                        </div>
                        <div class="field col-2">
                            <label>Tipo Ch. Pix</label>
                            <select formControlName="tipoChavePix">
                                <option value="">Selecione...</option>
                                <option *ngFor="let t of tiposChavePix" [value]="t">{{ t }}</option>
                            </select>
                        </div>
                        <div class="field col-4">
                            <label>Chave Pix</label>
                            <input type="text" formControlName="chavePix" maxlength="80">
                        </div>
                        <div class="field col-3">
                            <label>Descri&ccedil;&atilde;o</label>
                            <input type="text" formControlName="descricao" maxlength="120">
                        </div>
                        <div class="field col-3" style="display: flex; gap: 16px; align-items: flex-end; padding-bottom: 6px;">
                            <label class="switch"><input type="checkbox" formControlName="contaPgto"><span class="slider"></span><span class="switch-text">Pgto</span></label>
                            <label class="switch"><input type="checkbox" formControlName="ativa" (change)="aoMudarAtivaRefBancaria(i)"><span class="slider"></span><span class="switch-text">Ativa</span></label>
                        </div>
                    </div>
                </div>
                <div *ngIf="refsBancariasFormArray.length === 0" style="font-size: 11px; color: var(--text-muted); padding-top: 8px;">Nenhuma refer&ecirc;ncia banc&aacute;ria.</div>
            </div>
        </div>

        <!-- CARD ENDEREÇOS COM IE -->
        <div class="card" style="margin-top: 12px;">
            <div class="card-title" style="justify-content: space-between;">
                Endere&ccedil;os
                <button type="button" class="btn secondary btn-sm" (click)="adicionarEndereco()">+ Adicionar Endere&ccedil;o</button>
            </div>
            <div formArrayName="enderecos">
                <div *ngFor="let endCtrl of enderecosFormArray.controls; let i = index" [formGroupName]="i" class="sub-card">
                    <div class="sub-card-header">
                        <strong>Endere&ccedil;o {{ i + 1 }}</strong>
                        <button type="button" class="busca-combo-clear" (click)="removerEndereco(i)" *ngIf="enderecosFormArray.length > 1">✕</button>
                    </div>
                    <div class="sub-card-body form-grid">
                        <div class="field col-3">
                            <label>Tipo Endere&ccedil;o</label>
                            <select formControlName="tipoEndereco">
                                <option value="BOLETO">Boleto</option>
                                <option value="COBRANCA">Cobran&ccedil;a</option>
                                <option value="COMERCIAL">Comercial</option>
                                <option value="CORRESP">Correspondência</option>
                                <option value="ENTREGA">Entrega</option>
                                <option value="FATUR">Faturamento</option>
                                <option value="OUTRO">Outro</option>
                                <option value="RECADO">Recado</option>
                            </select>
                        </div>
                        <div class="field col-3">
                            <label>CEP</label>
                            <input type="text" formControlName="cep" maxlength="9" (input)="aplicarMascaraCep($event, i)" (blur)="onBlurCep($event, i)" [class.campo-invalido]="endCtrl.get('cep')?.touched && endCtrl.get('cep')?.invalid">
                        </div>
                        <div class="field col-3">
                            <label>Cidade<span class="campo-obrigatorio-asterisco">*</span></label>
                            <div class="busca-combo"><button type="button" class="btn-busca" (click)="abrirBuscaCidade(i)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg></button><input type="text" class="busca-combo-input" [value]="valorExibidoCidade(endCtrl.get('codCid')?.value)" (input)="onInputCodigo($event, 'codCid', i, enderecosFormArray)"><button type="button" class="busca-combo-clear" *ngIf="endCtrl.get('codCid')?.value" (click)="limparCampoConsulta('codCid', i, enderecosFormArray)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button></div>
                        </div>
                        <div class="field col-3">
                            <label>Bairro</label>
                            <div class="busca-combo"><button type="button" class="btn-busca" (click)="abrirBuscaBairro(i)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg></button><input type="text" class="busca-combo-input" [value]="valorExibido(endCtrl.get('codBai')?.value, bairros(), 'CODBAI', 'NOMEBAI')" (input)="onInputCodigo($event, 'codBai', i, enderecosFormArray)"><button type="button" class="busca-combo-clear" *ngIf="endCtrl.get('codBai')?.value" (click)="limparCampoConsulta('codBai', i, enderecosFormArray)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button></div>
                        </div>
                        <div class="field col-3">
                            <label>Logradouro</label>
                            <div class="busca-combo"><button type="button" class="btn-busca" (click)="abrirBuscaLogradouro(i)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg></button><input type="text" class="busca-combo-input" [value]="valorExibido(endCtrl.get('codEnd')?.value, logradouros(), 'CODEND', 'NOMEEND')" (input)="onInputCodigo($event, 'codEnd', i, enderecosFormArray)"><button type="button" class="busca-combo-clear" *ngIf="endCtrl.get('codEnd')?.value" (click)="limparCampoConsulta('codEnd', i, enderecosFormArray)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button></div>
                        </div>
                        <div class="field col-3"><label>Número</label><input type="text" formControlName="numeroEndereco"></div>
                        <div class="field col-3"><label>Complemento</label><input type="text" formControlName="complemento"></div>
                        <div class="field col-3"><label>Inscri&ccedil;&atilde;o Estadual</label><input type="text" formControlName="inscricaoEstadual"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CARD TRIBUTAÇÃO ENXUTO -->
        <div class="sub-card">
            <div class="sub-card-header"><strong>Tributa&ccedil;&atilde;o e Fiscal</strong></div>
            <div class="sub-card-body form-grid">
                <div class="field col-3">
                    <label>Classif. ICMS</label>
                    <select formControlName="classificIcms">
                        <option value="X">Contribuinte</option>
                        <option value="C">N&atilde;o Contribuinte</option>
                        <option value="I">Isento</option>
                        <option value="P">Produtor Rural</option>
                        <option value="R">Revendedor</option>
                    </select>
                </div>
                <div class="field col-3">
                    <label>Cons. Final</label>
                    <select formControlName="consumidorFinal"><option value="S">Sim</option><option value="N">N&atilde;o</option></select>
                </div>
                <div class="field col-3">
                    <label>Código Sit.Trib. IPI Entrada</label>
                    <select formControlName="ipiEntrada"><option *ngFor="let ipi of opcoesIpiEntrada" [value]="ipi.valor">{{ ipi.descricao }}</option></select>
                </div>
                <div class="field col-3">
                    <label>Código Sit.Trib. IPI Sa&iacute;da</label>
                    <select formControlName="ipiSaida"><option *ngFor="let ipi of opcoesIpiSaida" [value]="ipi.valor">{{ ipi.descricao }}</option></select>
                </div>
                <div class="field col-3">
                    <label>IPI incide no cálculo do ICMS</label>
                    <div style="height: 32px; display: flex; align-items: center;">
                        <label class="switch">
                            <input type="checkbox" formControlName="ipiIncideIcms">
                            <span class="slider"></span>
                        </label>
                    </div>
                </div>
                <div class="field col-3">
                    <label>Tem IPI</label>
                    <div style="height: 32px; display: flex; align-items: center;">
                        <label class="switch">
                            <input type="checkbox" formControlName="temIpi">
                            <span class="slider"></span>
                        </label>
                    </div>
                </div>
                <div class="field col-3">
                    <label>Optante do Simples</label>
                    <div style="height: 32px; display: flex; align-items: center;">
                        <label class="switch">
                            <input type="checkbox" formControlName="optanteSimples">
                            <span class="slider"></span>
                        </label>
                    </div>
                </div>
                <div class="field col-3">
                    <label>Regime Tributário</label>
                    <select formControlName="regimeTributario">
                        <option value="">Selecione...</option>
                        <option value="REAL">Lucro Real</option>
                        <option value="PRESUMIDO">Lucro Presumido</option>
                    </select>
                </div>
            </div>
        </div>

        <!-- CARD CONTATOS -->
        <div class="card">
            <div class="card-title" style="justify-content: space-between;">
                Contatos Vinculados
                <button type="button" class="btn secondary btn-sm" (click)="adicionarContato()">+ Adicionar</button>
            </div>

            <div formArrayName="contatos">
                <div *ngFor="let cCtrl of contatosFormArray.controls; let i = index" [formGroupName]="i" class="sub-card">
                    <div class="sub-card-header">
                        <strong>Contato {{ i + 1 }}</strong>
                        <button type="button" class="busca-combo-clear" (click)="removerContato(i)" title="Remover">✕</button>
                    </div>
                    <div class="sub-card-body form-grid">
                        <div class="field col-2">
                            <label>Tipo</label>
                            <select formControlName="tipoTelefone" title="Tipo do telefone deste contato">
                                <option *ngFor="let t of tiposTelefone" [value]="t">{{ t }}</option>
                            </select>
                        </div>
                        <div class="field col-3">
                            <label>Nome do Contato <span class="campo-obrigatorio-asterisco">*</span></label>
                            <input type="text" formControlName="nome" [class.campo-invalido]="cCtrl.get('nome')?.touched && cCtrl.get('nome')?.invalid">
                        </div>
                        <div class="field col-3">
                            <label>E-mail</label>
                            <input type="email" formControlName="email" style="text-transform: lowercase;" (input)="emailMaiusculo($event, i)">
                        </div>
                        <div class="field col-2">
                            <label>Telefone</label>
                            <input type="text" formControlName="telefone" (input)="aplicarMascaraTelefoneContato($event, i, 'telefone')">
                        </div>
                        <div class="field col-2">
                            <label>Celular</label>
                            <input type="text" formControlName="celular" (input)="aplicarMascaraTelefoneContato($event, i, 'celular')">
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="contatosFormArray.length === 0" style="font-size: 11px; color: var(--text-muted); padding-top: 8px;">Nenhum contato adicionado.</div>
        </div>

        <!-- CARD AERONAVES COM AUTOCOMPLETE -->
        <div class="card">
            <div class="card-title" style="justify-content: space-between;">
                Aeronaves
                <button type="button" class="btn secondary btn-sm" (click)="adicionarAeronave()">+ Adicionar</button>
            </div>

            <div formArrayName="aeronaves">
                <!-- Container Grid que divide em 2 colunas -->
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">

                    <!-- Loop de Aeronaves -->
                    <div *ngFor="let aeroCtrl of aeronavesFormArray.controls; let i = index" [formGroupName]="i" class="sub-card" style="margin-bottom: 0;">
                        <div class="sub-card-header">
                            <strong>Aeronave {{ i + 1 }}</strong>
                            <button type="button" class="busca-combo-clear" (click)="removerAeronave(i)">✕</button>
                        </div>
                        <div class="sub-card-body form-grid">
                            <!-- Aeronave (col-12 para ter um bom espaço dentro do card dividido) -->
                            <div class="field col-6" style="position: relative;" [class.busca-autocomplete-aberta]="dropdownAeronaveAberto() === i">
                                <label>Código / Prefixo <span class="campo-obrigatorio-asterisco">*</span></label>
                                <div class="busca-combo" [class.campo-invalido]="aeroCtrl.get('codAero')?.touched && aeroCtrl.get('codAero')?.invalid">
                                    <button type="button" class="btn-busca" (click)="abrirBuscaAeronave(i)">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                    </button>
                                    <input type="text" class="busca-combo-input"
                                           [value]="valorExibido(aeroCtrl.get('codAero')?.value, aeronaves(), 'CODAERO', 'PREFIXO')"
                                           (input)="onInputAeronave($event, i)"
                                           (keydown)="onKeyDownNavegacao($event, 'AERONAVE', i)"
                                           (blur)="fecharDropdownAeronave()">
                                </div>

                                <!-- AUTOCOMPLETE DROPDOWN -->
                                <div class="autocomplete-dropdown" *ngIf="dropdownAeronaveAberto() === i">
                                    <div class="autocomplete-item"
                                         *ngFor="let a of aeronavesFiltradasInline(i); let idx = index"
                                         [class.autocomplete-item-ativo]="indiceFocoAtual() === idx"
                                         (mousedown)="selecionarAeronaveInline(a, i)">
                                        {{a.CODAERO}} - {{a.PREFIXO}}
                                    </div>
                                    <div class="autocomplete-empty" *ngIf="aeronavesFiltradasInline(i).length === 0">Nenhuma encontrada.</div>
                                </div>
                            </div>

                            <!-- Tipo de Vínculo (col-12) -->
                            <div class="field col-6">
                                <label>Tipo de Vínculo <span class="campo-obrigatorio-asterisco">*</span></label>
                                <select formControlName="tipoVinculo" [class.campo-invalido]="aeroCtrl.get('tipoVinculo')?.touched && aeroCtrl.get('tipoVinculo')?.invalid">
                                    <option value="">Selecione...</option>
                                    <option value="PROPRIET">Proprietário</option>
                                    <option value="OFICINA">Oficina</option>
                                    <option value="PILOTO">Piloto</option>
                                    <option value="RESPONS">Responsável</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Mensagem quando vazio -->
                <div *ngIf="aeronavesFormArray.length === 0" style="font-size: 11px; color: var(--text-muted); padding-top: 8px;">Nenhuma aeronave vinculada.</div>
            </div>
        </div>
        <div class="sub-card">
            <div class="sub-card-header" style="justify-content: space-between;">
                <strong>Anexo de Documentos</strong>
            </div>

            <!-- Container único: Tudo na mesma linha (Botão + Arquivos) alinhado à esquerda -->
            <div class="sub-card-body" style="display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-start; gap: 12px;">

                <!-- Botão de Upload (flex-shrink: 0 impede ele de ser esmagado se tiver muitos arquivos) -->
                <button type="button" class="btn secondary btn-sm" (click)="fileInput.click()" title="Escolher arquivos do computador" style="flex-shrink: 0;">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="17 8 12 3 7 8"></polyline>
                        <line x1="12" y1="3" x2="12" y2="15"></line>
                    </svg>
                    Selecionar Arquivos
                </button>

                <!-- O input real escondido -->
                <input #fileInput type="file" multiple (change)="onFileSelected($event)" style="display: none;">

                <!-- Texto informativo sutil (Some quando tem anexos) -->
                <span style="font-size: 12px; color: var(--text-muted);" *ngIf="arquivosPendentes.length === 0 && arquivosExistentes.length === 0">
                    Nenhum arquivo anexado.
                </span>

                <!-- Anexos (existentes + novos) na ordem escolhida: arraste ou use as setas -->
                <ng-container *ngIf="arquivosPendentes.length + arquivosExistentes.length > 0">
                    <!-- anexos existentes e novos -->

                    <div style="width: 100%; font-size: 11px; color: var(--text-muted);">
                        Arraste os arquivos para definir a ordem. A ordem é salva ao clicar em Salvar.
                    </div>
                    <div *ngFor="let it of anexosOrdenados(); let i = index; let first = first; let last = last; trackBy: trackAnexo"
                         draggable="true" (dragstart)="onAnexoDragStart(i)" (dragover)="$event.preventDefault()" (drop)="onAnexoDrop(i)"
                         [style.background]="it.tipo === 'E' ? '#E8F5E9' : '#f1f5f9'"
                         [style.border]="it.tipo === 'E' ? '1px solid #C8E6C9' : '1px solid #cbd5e1'"
                         style="width: 170px; box-sizing: border-box; padding: 6px; border-radius: 6px; display: flex; flex-direction: column; gap: 6px; cursor: grab; overflow: hidden; flex-shrink: 0; position: relative;">
                        <!-- Excluir: canto superior direito, com confirmação -->
                        <button type="button" (click)="pedirExclusaoAnexo(it)" title="Excluir anexo"
                                style="position: absolute; top: 4px; right: 4px; z-index: 2; width: 20px; height: 20px; padding: 0; border: 1px solid #fecaca; border-radius: 50%; background: #fff; color: var(--danger); font-size: 11px; font-weight: bold; line-height: 1; cursor: pointer; display: flex; align-items: center; justify-content: center;">✕</button>
                        <!-- Miniatura: imagem ou PDF; clique abre o preview grande -->
                        <ng-container *ngIf="thumbDe(it) as th">
                            <div (click)="abrirPreviewAnexo(it)" [title]="'Clique para ampliar: ' + it.nome"
                                 style="position: relative; height: 120px; background: #fff; border: 1px solid #e2e8f0; border-radius: 4px; overflow: hidden; display: flex; align-items: center; justify-content: center; cursor: pointer;">
                                <span *ngIf="th.carregando" style="font-size: 11px; color: var(--text-muted);">Carregando...</span>
                                <img *ngIf="!th.carregando && th.tipo === 'img' && th.url" [src]="th.url" [alt]="it.nome" draggable="false"
                                     style="max-width: 100%; max-height: 100%; object-fit: contain;">
                                <iframe *ngIf="!th.carregando && th.tipo === 'pdf' && th.safe" [src]="th.safe" tabindex="-1"
                                        style="width: calc(100% + 24px); height: calc(100% + 24px); border: 0; pointer-events: none; align-self: flex-start;"></iframe>
                                <span *ngIf="!th.carregando && th.tipo === 'outro'" style="font-size: 28px;">📄</span>
                            </div>
                        </ng-container>
                        <div style="display: flex; align-items: center; gap: 4px; width: 100%; min-width: 0; box-sizing: border-box;">
                            <span style="font-size: 11px; font-weight: 700; color: var(--text-muted);">{{ i + 1 }}</span>
                            <span [title]="it.nome" style="font-size: 11px; flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ it.nome }}</span>
                        <button *ngIf="it.tipo === 'E'" type="button" class="file-item-remove" style="background: none; border: none; color: var(--primary); cursor: pointer; display: flex;" (click)="fazerDownloadAnexo(it.ex)" title="Baixar Anexo">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                        </button>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
    </form>
</div>

<!-- Preview de anexo (PDF / imagem) -->
<div *ngIf="previewAberto()" (click)="fecharPreviewAnexo()"
     style="position: fixed; inset: 0; background: rgba(15,23,42,0.6); z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 24px;">
    <div (click)="$event.stopPropagation()"
         style="background: #fff; border-radius: 10px; width: min(1000px, 95vw); height: min(90vh, 900px); display: flex; flex-direction: column; overflow: hidden; box-shadow: 0 20px 50px rgba(0,0,0,0.35);">
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 16px; border-bottom: 1px solid #e2e8f0;">
            <strong style="font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ previewNome }} <span style="font-weight: 400; color: var(--text-muted);">({{ previewIndice() + 1 }} de {{ previewTotal() }})</span></strong>
            <button type="button" (click)="fecharPreviewAnexo()" title="Fechar"
                    style="background: none; border: none; font-size: 22px; cursor: pointer; line-height: 1;">×</button>
        </div>
        <div style="position: relative; flex: 1; min-height: 0; display: flex; align-items: center; justify-content: center; background: #f1f5f9; overflow: auto;">
            <button type="button" *ngIf="previewIndice() > 0" (click)="navegarPreview(-1)" title="Anterior"
                    style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); z-index: 3; width: 38px; height: 38px; border-radius: 50%; border: none; background: rgba(15,23,42,0.75); color: #fff; font-size: 22px; line-height: 1; cursor: pointer; display: flex; align-items: center; justify-content: center;">‹</button>
            <button type="button" *ngIf="previewIndice() >= 0 && previewIndice() < previewTotal() - 1" (click)="navegarPreview(1)" title="Próximo"
                    style="position: absolute; right: 26px; top: 50%; transform: translateY(-50%); z-index: 3; width: 38px; height: 38px; border-radius: 50%; border: none; background: rgba(15,23,42,0.75); color: #fff; font-size: 22px; line-height: 1; cursor: pointer; display: flex; align-items: center; justify-content: center;">›</button>
            <span *ngIf="previewCarregando()" style="font-size: 13px; color: var(--text-muted);">Carregando...</span>
            <ng-container *ngIf="!previewCarregando()">
                <iframe *ngIf="previewTipo === 'pdf' && previewUrl" [src]="previewUrl" style="width: 100%; height: 100%; border: 0;"></iframe>
                <img *ngIf="previewTipo === 'img' && previewUrl" [src]="$any(previewUrl)" [alt]="previewNome" style="max-width: 100%; max-height: 100%; object-fit: contain;">
                <span *ngIf="previewTipo === 'outro'" style="font-size: 13px; color: var(--text-muted); padding: 24px; text-align: center;">
                    Sem pré-visualização para este tipo de arquivo. Use o botão de baixar.
                </span>
            </ng-container>
        </div>
    </div>
</div>

<!-- ========================================== -->
<!-- MODALS DE BUSCA (Estilo Sankhya Nativo)    -->
<!-- ========================================== -->

<!-- Modal Cidade -->
<div class="modal-overlay" *ngIf="cidadeModalAberta()">
    <div class="modal-box">
        <div class="modal-header">Procurando por Cidade</div>
        <div class="modal-body">
            <div style="display: flex; gap: 8px; margin-bottom: 10px;">
                <select class="busca-modal-input" style="width: 90px; margin-bottom: 0;" [ngModel]="ufSelecionada()" (ngModelChange)="ufSelecionada.set($event)">
                    <option value="">UF</option>
                    <!-- NOTA: Verifique se as propriedades 'CODUF' ou 'UF' coincidem com o retorno da sua API -->
                    <option *ngFor="let uf of ufs()" [value]="uf.CODUF">{{ uf.UF }}</option>
                </select>

                <input type="text" class="busca-modal-input" style="margin-bottom: 0; flex: 1;" [ngModel]="filtroBusca()" (ngModelChange)="onFiltroBuscaChange($event, 'CIDADE')" placeholder="Digite o que você procura" autofocus>
            </div>
            <div class="busca-modal-lista">
                <div class="busca-modal-item" *ngFor="let c of cidadesFiltradas()" (click)="selecionarCidade(c)">
                    {{c.CODCID}} - {{c.NOMECID}} <strong *ngIf="c.UF">({{ obterSiglaUf(c.UF) }})</strong>
                </div>
                <div class="busca-modal-empty" *ngIf="cidadesFiltradas().length === 0" style="padding: 16px; text-align: center;">
                    <span style="color: var(--text-muted); font-size: 11px; display: block; margin-bottom: 10px;">Cidade n&atilde;o encontrada.</span>
                    <button type="button" class="btn primary" style="width: 100%; justify-content: center;" (click)="cadastrarNovaCidade()" [disabled]="salvando() || !filtroBusca()">
                        {{ salvando() ? 'Cadastrando...' : 'Cadastrar "' + filtroBusca() + '"' }}
                    </button>

                    <!-- Aviso caso tente cadastrar sem selecionar a UF -->
                    <span *ngIf="!ufSelecionada() && filtroBusca()" style="color: var(--danger); font-size: 10px; display: block; margin-top: 6px; font-weight: bold;">
                        Selecione uma UF no filtro acima para cadastrar.
                    </span>
                </div>
            </div>
        </div>
        <div class="modal-footer"><button class="modal-btn confirm" (click)="cidadeModalAberta.set(false)">Cancelar</button></div>
    </div>
</div>

<!-- Modal Logradouro -->
<div class="modal-overlay" *ngIf="logradouroModalAberta()">
    <div class="modal-box">
        <div class="modal-header">Procurando por Logradouro</div>
        <div class="modal-body">
            <input type="text" class="busca-modal-input" [ngModel]="filtroBusca()" (ngModelChange)="onFiltroBuscaChange($event, 'LOGRADOURO')" placeholder="Digite o que você procura" autofocus>
            <div class="busca-modal-lista">
                <div class="busca-modal-item" *ngFor="let l of logradourosFiltrados()" (click)="selecionarLogradouro(l)">
                    {{l.CODEND}} - {{l.NOMEEND}}
                </div>
                <div class="busca-modal-empty" *ngIf="logradourosFiltrados().length === 0" style="padding: 16px; text-align: center;">
                    <span style="color: var(--text-muted); font-size: 11px; display: block; margin-bottom: 10px;">Logradouro n&atilde;o encontrado.</span>
                    <button type="button" class="btn primary" style="width: 100%; justify-content: center;" (click)="cadastrarNovoLogradouro()" [disabled]="salvando() || !filtroBusca()">
                        {{ salvando() ? 'Cadastrando...' : 'Cadastrar "' + filtroBusca() + '"' }}
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-footer"><button class="modal-btn confirm" (click)="logradouroModalAberta.set(false)">Cancelar</button></div>
    </div>
</div>

<!-- Modal Confirmar Novo Logradouro -->
<div class="modal-overlay" *ngIf="modalNovoLogradouroAberto()">
    <div class="modal-box">
        <div class="modal-header" style="color: var(--danger);">Aten&ccedil;&atilde;o: Logradouro n&atilde;o encontrado</div>
        <div class="modal-body">
            A rua <strong>{{ logradouroPendente().nome }}</strong> n&atilde;o foi encontrada no banco de dados do Sankhya. <br><br>
            Deseja cadastrar esse logradouro no sistema agora?
        </div>
        <div class="modal-footer">
            <button class="modal-btn secondary" (click)="modalNovoLogradouroAberto.set(false)">N&atilde;o, buscar na lupa</button>
            <button class="modal-btn confirm" [disabled]="salvando()" (click)="confirmarCadastroLogradouro()">
                {{ salvando() ? 'Cadastrando...' : 'Sim, cadastrar' }}
            </button>
        </div>
    </div>
</div>

<!-- Modal Bairro -->
<div class="modal-overlay" *ngIf="bairroModalAberta()">
    <div class="modal-box">
        <div class="modal-header">Procurando por Bairro</div>
        <div class="modal-body">
            <input type="text" class="busca-modal-input" [ngModel]="filtroBusca()" (ngModelChange)="onFiltroBuscaChange($event, 'BAIRRO')" placeholder="Digite o que você procura" autofocus>
            <div class="busca-modal-lista">
                <div class="busca-modal-item" *ngFor="let b of bairrosFiltrados()" (click)="selecionarBairro(b)">
                    {{b.CODBAI}} - {{b.NOMEBAI}}
                </div>
                <div class="busca-modal-empty" *ngIf="bairrosFiltrados().length === 0" style="padding: 16px; text-align: center;">
                    <span style="color: var(--text-muted); font-size: 11px; display: block; margin-bottom: 10px;">Bairro n&atilde;o encontrado.</span>
                    <button type="button" class="btn primary" style="width: 100%; justify-content: center;" (click)="cadastrarNovoBairro()" [disabled]="salvando() || !filtroBusca()">
                        {{ salvando() ? 'Cadastrando...' : 'Cadastrar "' + filtroBusca() + '"' }}
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-footer"><button class="modal-btn confirm" (click)="bairroModalAberta.set(false)">Cancelar</button></div>
    </div>
</div>

<!-- Modal Aeronave (DE VOLTA AO SEU LUGAR!) -->
<div class="modal-overlay" *ngIf="aeronaveModalAberta()">
    <div class="modal-box">
        <div class="modal-header">Procurando por Aeronave</div>
        <div class="modal-body">
            <input type="text" class="busca-modal-input" [ngModel]="filtroBusca()" (ngModelChange)="onFiltroBuscaChange($event, 'AERONAVE')" placeholder="Digite o que você procura" autofocus>
            <div class="busca-modal-lista">
                <div class="busca-modal-item" *ngFor="let a of aeronavesFiltradas()" (click)="selecionarAeronave(a)">
                    {{a.CODAERO}} - {{a.PREFIXO}}
                </div>
                <div class="busca-modal-empty" *ngIf="aeronavesFiltradas().length === 0">Nenhuma encontrada.</div>
            </div>
        </div>
        <div class="modal-footer"><button class="modal-btn confirm" (click)="aeronaveModalAberta.set(false)">Cancelar</button></div>
    </div>
</div>

<!-- Modal Fiador -->
<div class="modal-overlay" *ngIf="modalFiadorAberta()">
    <div class="modal-box">
        <div class="modal-header">
            Buscar Parceiro (Fiador)
        </div>
        <div class="modal-body">
            <input type="text" class="busca-modal-input"
                   [(ngModel)]="filtroBuscaModalFiador"
                   [ngModelOptions]="{standalone: true}"
                   (input)="agendarBuscaFiadoresModal()"
                   placeholder="Digite o nome, código ou documento..." autofocus>

            <div class="busca-modal-lista">
                <div class="busca-modal-item" *ngFor="let p of listaFiadoresSugeridos()" (click)="selecionarFiadorModal(p)">
                    <div style="font-weight: 700; color: var(--text-main); margin-bottom: 2px;">{{ p.nomeparc }}</div>
                    <div style="font-size: 10px; color: var(--text-muted);">
                        Código: <strong>{{ p.codparc }}</strong> | Doc: {{ p.docparc || 'Não informado' }}
                    </div>
                </div>
                <div class="busca-modal-empty" *ngIf="!listaFiadoresSugeridos().length" style="padding: 16px; text-align: center; color: var(--text-muted); font-size: 11px;">
                    {{ statusBuscaFiador() }}
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn secondary" (click)="fecharModalFiador()">Cancelar</button>
        </div>
    </div>
</div>

<div class="toast-container" *ngIf="toast()">
    <div class="toast-box" [ngClass]="toast()?.tipo">
        <span class="toast-mensagem">{{ toast()?.mensagem }}</span>
        <button type="button" class="toast-fechar" (click)="toast.set(null)">✕</button>
    </div>
</div>

<!-- Modal Confirmar Limpeza -->
<div class="modal-overlay" *ngIf="modalConfirmarLimparAberto()">
    <div class="modal-box">
        <div class="modal-header" style="color: var(--danger);">Confirmar Limpeza</div>
        <div class="modal-body">
            Tem certeza que deseja limpar todos os dados do formulário? <br><br>
            <strong>As informações não salvas serão perdidas permanentemente.</strong>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn secondary" (click)="cancelarLimpeza()">Cancelar</button>
            <button type="button" class="btn" style="background: var(--danger); color: white;" (click)="confirmarLimpeza()">Sim, limpar dados</button>
        </div>
    </div>
</div>

<!-- Modal Confirmar Exclusão de Anexo -->
<div class="modal-overlay" *ngIf="anexoParaConfirmar() as an">
    <div class="modal-box">
        <div class="modal-header" style="color: var(--danger);">Excluir Anexo</div>
        <div class="modal-body">
            Deseja realmente excluir o arquivo <strong>{{ an.nome }}</strong>?
        </div>
        <div class="modal-footer">
            <button type="button" class="btn secondary" (click)="cancelarExclusaoAnexo()">Cancelar</button>
            <button type="button" class="btn" style="background: var(--danger); color: white;" (click)="confirmarExclusaoAnexo()">Sim, excluir</button>
        </div>
    </div>
</div>

<!-- Modal Confirmar Salvamento -->
<div class="modal-overlay" *ngIf="modalConfirmarSalvarAberto()">
    <div class="modal-box">
        <div class="modal-header" style="color: var(--primary);">Confirmar Salvamento</div>
        <div class="modal-body">
            Deseja realmente salvar e vincular os dados deste parceiro no sistema Sankhya?
        </div>
        <div class="modal-footer">
            <button type="button" class="btn secondary"
                    [disabled]="salvando()"
                    (click)="cancelarSalvamento()">
                Revisar dados
            </button>
            <button type="button" class="btn primary"
                    [disabled]="salvando()"
                    (click)="confirmarSalvamento()">
                <!-- Show a spinner if saving -->
                <app-loading-indicator *ngIf="salvando()" size="inline"></app-loading-indicator>
                {{ salvando() ? 'Salvando...' : 'Sim, salvar parceiro' }}
            </button>
        </div>
    </div>
</div>
